export const COLORS = {
  purple: "#CDB9FF",
  offWhite: "#FAFAFA",
  lightWhite: "#D4D4D8",
  white: "#ffffff",
  lightblack: "#09090b",
  gray: "#3F3F46",
  darkGray: "#05164D",
  blue: "#00A3BC",
  darkBlue: "#0068FF",
  "blue-100": "#233d40",
  "blue-200": "#e5ffff",
  "sleap-gray-850": "#27272A",
  "light-gray": "#71717A",
  "sleap-light-blue": "#42E6FF",
  black: "#000000",
  "green-100": "#b5fbbf",
  "green-200": "#194a21",
  "yellow-100": "#ffedcc",
  "yellow-200": "#524022",
  lightGreen: "#00C11F",
  darkGreen: "#00991F",
  skyBlue: "#00FFFF",
  yellow: "#FFA500",
  current: "currentColor",
};
